import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { selector } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per part of the meeting: open (indigo), activity (yellow), discuss & close (green) */
const blockStyles = [{
  box: 'bg-mist',
  head: 'text-brand',
  dot: 'bg-brand text-white'
}, {
  box: 'bg-sun-soft',
  head: 'text-ink',
  dot: 'bg-sun text-ink'
}, {
  box: 'bg-leaf-soft',
  head: 'text-leaf-ink',
  dot: 'bg-leaf text-white'
}];

/** "What does your team need this week?" — pick a situation, see the meeting that solves it */
export function MeetingSelector() {
  const [active, setActive] = useState(0);
  const item = selector.items[active];
  const blocks = [item.open, item.activity, item.close];
  return <section aria-labelledby="selector-title" className="bg-mist py-12 md:py-20" data-id="element-141" data-mp="2i1z9y60qus42">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-142" data-mp="2d2cudpxg0zs3">
        <SectionHeading id="selector-title" eyebrow={selector.eyebrow} title={selector.title} sub={selector.sub} data-id="element-143" data-mp="2d2we9c6nly8r" />

        <div className="mx-auto mt-8 grid max-w-[980px] gap-5 md:mt-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start" data-id="element-144" data-mp="1pxway0sorxg0">
          <div role="tablist" aria-orientation="vertical" aria-label="Team situations" className="flex flex-col gap-2.5" data-id="element-145" data-mp="1usimc3yrpq03">
            {selector.items.map((it, i) => {
            const on = i === active;
            return <button key={it.tab} role="tab" type="button" aria-selected={on} aria-controls="selector-panel" onClick={() => setActive(i)} className={`flex min-h-[56px] w-full items-center justify-between gap-3 rounded-xl border-2 px-4 text-left text-[16px] font-semibold transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand ${on ? 'border-brand bg-white text-brand' : 'border-transparent bg-white text-ink hover:border-mist-line'}`} data-id="element-146" data-mp="28q7bvp3s5lbh" data-mpi={i}>
                  {it.tab}
                  <ArrowRightIcon className={`h-5 w-5 shrink-0 ${on ? 'text-brand' : 'text-ink/40'}`} strokeWidth={2.25} aria-hidden="true" data-id="element-147" data-mp="2q0kwq82r6mqm" />
                </button>;
          })}
          </div>

          <div id="selector-panel" role="tabpanel" className="overflow-hidden rounded-2xl border border-mist-line bg-white" data-id="element-148" data-mp="2g7vorn6evr01">
            <div className="bg-brand p-5 md:p-7" data-id="element-149" data-mp="279jo0sbtzctv">
              <p className="font-display text-[11px] font-extrabold tracking-[0.14em] text-sun" data-id="element-150" data-mp="277qjbiks32oi">
                {selector.startLabel} · {item.n}
              </p>
              <h3 className="mt-2 font-display text-[24px] font-black uppercase leading-tight tracking-tight text-white md:text-[28px]" data-id="element-151" data-mp="1xbx7k1evvd7s">{item.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-white/85" data-id="element-152" data-mp="graxbssaswu">{item.goal}</p>
            </div>

            <div className="space-y-3 p-4 md:p-6" data-id="element-153" data-mp="3rnc00pza3qr8">
              {blocks.map((list, b) => {
              const s = blockStyles[b];
              return <div key={selector.columns[b]} className={`rounded-xl p-4 ${s.box}`} data-id="element-154" data-mp="80s6xqcwtf01" data-mpi={b}>
                    <h4 className={`font-display text-[12px] font-black tracking-[0.12em] ${s.head}`} data-id="element-155" data-mp="cue9uqt9u4in">{selector.columns[b]}</h4>
                    <ul className="mt-2.5 space-y-2" data-id="element-156" data-mp="hrejtct8rrf1">
                      {list.map(line => <li key={line} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-157" data-mp="3gbwhax54t9ij">
                          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${s.dot}`} data-id="element-158" data-mp="3lazbtnnhjxc9">
                            <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-159" data-mp="3v6swjubcyx54" />
                          </span>
                          {line}
                        </li>)}
                    </ul>
                  </div>;
            })}
              <p className="pt-1 text-center text-[14px] font-medium text-ink/60" data-id="element-160" data-mp="1826th54e0q2f">{selector.note}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}